module.exports = __webpack_public_path__ + "static/media/eventpage-1th.7fbfcb3e.svg";